export function buildPlannerSubmitData({
  transitOptions,
  originCoordinates,
  destinationCoordinates,
  administrativeAreaTimeZone,
  otpUrl,
  originDirection,
  destinationDirection,
  selectedTransports,
  selectedOperators,
  operatorOptions,
  selectedTime,
  transportModeCalls
}) {
  return {
    transitOptions,
    originCoordinates,
    destinationCoordinates,
    administrativeAreaTimeZone,
    otp_url: otpUrl,
    originDirection,
    destinationDirection,
    selectedTransports,
    selectedOperators,
    operatorOptions,
    selectedTime,
    transportModeCalls
  }
}

export function buildPlannerStoreCommitEntries({
  origin,
  destination,
  originCoordinates,
  destinationCoordinates,
  selectedTransports,
  timeMode,
  timeModeHour,
  timeModeDate,
  googleRoutesResponse,
  selectedTime,
  selectedOperators
}) {
  return [
    ['setPlannerOrigin', origin],
    ['setPlannerDestination', destination],
    ['setPlannerOriginCoordinates', originCoordinates],
    ['setPlannerDestinationCoordinates', destinationCoordinates],
    ['setPlannerSelectedTransports', selectedTransports],
    ['setPlannerTimeMode', timeMode],
    ['setPlannerTimeModeHour', timeModeHour],
    ['setPlannerTimeModeDate', timeModeDate],
    ['setGooglePlannerResponse', googleRoutesResponse],
    ['setPlannerSelectedTime', selectedTime],
    ['setPlannerSelectedOperators', selectedOperators]
  ]
}
